import React, {useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {makeStyles} from '@mui/styles';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from 'universal-cookie';
import {useAuth} from "../utils/useAuth";

const AddNewProducts = (props) => {
    const [input, setInput] = useState("");
    const [items, setItems] = useState([]);
    const [searching, setSearching] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState(false);
    const {getAccessToken, logout} = useAuth();


    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            height: 400,
            maxWidth: 300,
            backgroundColor: theme.palette.background.paper,
        },
    }))

    const classes = useStyles();

    function openAlert(message) {
        setOpen(true)
        setMessage(message)
    }

    function fetchDataBySMC(smc) {

        let formattedSMC = smc.slice(0, 6) + "-" + smc.slice(6, 11) + "-" + smc.slice(11, 15)
        let imgLink = "http://getimage.emea.guccigroup.dom/getimage/?Cod=" + formattedSMC

        const newItem = {
            id: generateUniqSerial(),
            name: "N/A",
            hotspostID: props.hotspot.id,
            sku: "N/A",
            smc: smc,
            imageLink: imgLink,
            timestamp: Math.floor(Date.now() / 1000).toString(),
            createdBy: "",
            visibilityColorWeb: true,
            visibilityBrandExperience: true,
            position: ""

        }
        setItems([...items, newItem])
    }

    async function fetchDataBySKU() {
        setSearching(true)
        try {
            const data = new URLSearchParams();
            data.append('bID', 'com.gucci.corporate.ccms-vtmap');

            const response = await fetch(`/asshadow/api/?getSTYLECOLORbySKU=${input}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': '4ae1d3b0-f76f-4d76-a21f-16106a126132',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data.toString(),
                }
            );

            const result = await response.json();

            const message = result.Message;

            if (message !== "Ok") {
                openAlert(message);
                return;
            }

            const sku = result.SKUs?.[0];

            if (!sku) {
                openAlert("No SKU data found");
                return;
            }

            const smc = sku.Model + sku.Material + sku.Color;

            fetchDataBySMC(smc);

        } catch (error) {
            setSearching(false);
            openAlert(error.toString());
            console.log("Response Error... : ", error);
        }
    }


    async function saveProducts() {
        try {
            for (const item of items) {
                await postProduct(item);
            }

            props.setOpenDialogAddProducts(false);
            props.fetchDisplays();
            setItems([]);
        } catch (err) {
            console.error("Errore saveProducts:", err);
        }
    }


    async function postProduct(item) {
        try {
            const token = await getAccessToken();
            if (!token) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get('hashCode') || '';

            const res = await fetch(
                process.env.REACT_APP_API_ENDPOINT + "products",
                {
                    method: 'POST',
                    headers: {
                        Authorization: token + hashCode,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(item),
                }
            );

            if (!res.ok) {
                throw new Error(`POST product failed: ${res.status}`);
            }

            return await res.json();
        } catch (error) {
            console.error("Errore postProduct:", error);
            throw error;
        }
    }


    function generateUniqSerial() {
        return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, (c) => {
            const r = Math.floor(Math.random() * 16);
            return r.toString(16);
        });
    }

    return (
        <div>

            <Dialog open={props.openDialogAddProducts} onClose={() => props.setOpenDialogAddProducts(false)} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add new Products by {props.type}
                    <Button style={{ position: "absolute", right: "10px" }} onClick={() => saveProducts()} className='red template_button'>Save</Button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.type === "SMC" ? "Please lengthen this text to 15 characters." : "Please lengthen this text to 10 characters."}
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        label={props.type === "SMC" ? "Type Style Material Color" : "Type SKU"}
                        fullWidth
                        value={input}
                        onChange={e => setInput(e.target.value)}
                    />

                    <List style={{ maxHeight: 200, overflow: 'auto' }}>
                        {searching ? <CircularProgress /> : null}
                        {items.map((i) => (
                            <ListItemText primary={i.smc} />
                        ))}
                    </List>


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.setOpenDialogAddProducts(false)} className='black template_button'>
                        Cancel
                    </Button>

                    <Button onClick={() => { props.type === "SMC" ? fetchDataBySMC(input) : fetchDataBySKU() }} className='red template_button'>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"An error occurred while searching"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary" autoFocus>OK</Button>
                </DialogActions>
            </Dialog>
        </div>

    );
};

export default AddNewProducts
